var map = {
	"./Arun.png": 402,
	"./Arunlogo.jpg": 575,
	"./Arunlogo.png": 13,
	"./home.jpg": 834,
	"./proyecto-3.png": 118,
	"./proyecto-5.png": 603,
	"./proyecto-6.png": 115,
	"./proyecto-7.png": 476,
	"./proyecto-8.png": 560,
	"./proyecto-9.png": 727
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 327;